<template>
  <section>
    <section-header
      @toggle="showSection = !showSection"
      @showSort="showSortModal = true"
      :showSection="showSection"
      :section="section"
      :showSort="true"
      :showAdd="true"
    >
      <slot></slot>
    </section-header>

    <div class="content" v-if="showSection">
      <div v-if="!['Savage Worlds', 'Savage Embers'].includes(ruleset)">
        <passive
          v-for="item in passiveSkills"
          :item="item"
          :section="section"
          :attribute="getAttribute(item.attribute)"
          :skillBonus="skillBonus(item, getAttribute(item.attribute))"
          :key="`passive-${item._id}`"
        ></passive>
      </div>
      <skill
        v-for="item in items"
        :item="item"
        :section="section"
        :attribute="getAttribute(item.attribute)"
        :skillBonus="skillBonus(item, getAttribute(item.attribute))"
        :sizeModifier="pfrpgSizeModifier(item)"
        :armorClassPenalty="pfrpgArmorClassPenalty(item.attribute)"
        :passiveList="passiveList"
        :key="item._id"
      ></skill>
    </div>

    <ez-modal v-if="showSortModal" @close="showSortModal = false" size="m-tiny">
      <h3>Skills</h3>
      <sortable :section="section" :items="items"></sortable>
    </ez-modal>
  </section>
</template>
<script>
import { mapState } from "vuex";
import modal from "@/mixins/vue-ez-modal";
import Skill from "./_Skill.vue";
import Passive from "./_Passive.vue";
import SectionHeader from "../shared/_SectionHeader.vue";
import Sortable from "../shared/_Sortable.vue";

export default {
  name: "sheet-skills-index",
  mixins: [modal],
  components: {
    Skill,
    Passive,
    SectionHeader,
    Sortable,
  },
  data() {
    return {
      section: "skills",
      showSection: true,
      showSortModal: false,
      passiveList: ["Investigation", "Perception"],
    };
  },
  computed: {
    ...mapState({
      ruleset: (state) => state.characters.current.ruleset,
      armorClass: (state) => state.characters.current.defense.armorClass,
      experience: (state) => state.characters.current.core.experience,
      attributes: (state) => state.characters.current.attributes,
      items: (state) => state.characters.current.skills,
      size: (state) => state.characters.current.core.size,
      charisma: (state) => state.characters.current.core.charisma,
      health: (state) => state.characters.current.defense.health,
    }),
    proficiencyBonus() {
      return this.$rpgv.d20.proficiencyBonus(this.experience);
    },
    passiveSkills() {
      let skills = this.items;
      let list = [];
      this.passiveList.forEach((name) => {
        let skill = skills.find((s) => s.name === name);
        if (skill) {
          list.push(skill);
        }
      });
      return list;
    },
  },
  methods: {
    getAttribute(attribute) {
      return this.attributes.find((x) => x.name === attribute);
    },
    skillBonus(item, attribute) {
      if (["5th Edition", "5e24", "Solarian Conflict"].includes(this.ruleset))
        return this.fifthEditionBonus(item, attribute);
      if (this.ruleset === "PFRPG") return this.pfrpgBonus(item, attribute);
      if (["PF Playtest", "PFRPG2", "Embers RPG"].includes(this.ruleset))
        return this.pfrpg2Bonus(item, attribute);
      if (["Savage Worlds", "Savage Embers"].includes(this.ruleset))
        return this.savageBonus(item);
    },
    fifthEditionBonus(item, attribute) {
      let bonus = this.$rpgv.d20.attributeBonus(attribute);
      if (item.proficient) bonus += this.proficiencyBonus;
      if (item.expertise) bonus += this.proficiencyBonus;
      if (Number.isFinite(item.misc)) bonus += item.misc;
      return bonus;
    },
    pfrpgBonus(item, attribute) {
      let bonus = this.$rpgv.d20.attributeBonus(attribute);
      if (Number.isFinite(item.ranks)) bonus += item.ranks;
      if (Number.isFinite(item.misc)) bonus += item.misc;
      if (item.classSkill && Number.isFinite(item.ranks) && item.ranks > 0)
        bonus += 3;
      if (this.pfrpgSizeModifier(item)) bonus += this.pfrpgSizeModifier(item);
      if (Number.isFinite(this.pfrpgArmorClassPenalty(item.attribute)))
        bonus += this.pfrpgArmorClassPenalty(item.attribute);
      return bonus;
    },
    pfrpg2Bonus(item, attribute) {
      let bonus = this.$rulesets[this.ruleset].getProficiencyBonus(
        this.experience,
        item,
        attribute
      );
      if (Number.isFinite(this.pfrpgArmorClassPenalty(item.attribute)))
        bonus += this.pfrpgArmorClassPenalty(item.attribute);

      return bonus;
    },
    savageBonus(item) {
      let bonus = item.score == 0 ? -2 : 0;
      let charismaBonus = ["Persuasion", "Streetwise"].includes(item.name)
        ? parseInt(this.charisma, 10)
        : 0;

      bonus = bonus + charismaBonus + this.health.wounds + this.health.fatigue;
      bonus =
        item.misc && isFinite(item.misc)
          ? bonus + parseInt(item.misc, 10)
          : bonus;

      return bonus;
    },
    pfrpgSizeModifier(item) {
      let total;
      if (this.size && item.name === "Fly")
        total = this.$rpgv.d20.size[this.size].fly;
      if (this.size && item.name === "Stealth")
        total = this.$rpgv.d20.size[this.size].stealth;
      return total;
    },
    pfrpgArmorClassPenalty(attributeName) {
      let base = 0;
      if (["strength", "dexterity"].indexOf(attributeName) > -1) {
        if (
          this.armorClass.armor &&
          Number.isFinite(this.armorClass.armor.checkPenalty)
        )
          base += this.armorClass.armor.checkPenalty;
        if (
          this.armorClass.shield &&
          Number.isFinite(this.armorClass.shield.checkPenalty)
        )
          base += this.armorClass.shield.checkPenalty;
      }
      return base;
    },
  },
};
</script>
